// @flow
import modularui from "../_modularui/ModularUIConnector";

import type { ModularUIConnector } from "../_modularui/types";

/**
 * @deprecated - will be removed in the future, use the equivalent hook 'useTab' instead
 */
export const connectTab: ModularUIConnector = modularui(
  "Tab",
  ({ match }) => match.url,
  {
    propName: "tab",
  },
);
